import TextMediaAccordion, { TextMediaAccordionProps } from '@/components/_rebrand/TextMediaAccordion';
import SerifAndSansSerifHeadline from '@/components/_rebrand/craft/product/_organisms/SerifAndSansSerifHeadline';
import { parseHtml } from '@/lib/parse-html';
import { StyleOverride } from '@/types/craft-style-overrides';
import Image from 'next/image';

const displayProps = {
  title: null,
  features: [],
  styleOverrides: undefined,
  backgroundColor: 'bg-violet-100',
} as TextMediaAccordionProps;

interface AssetImageFromCraft {
  url: string;
  title: string;
  alt: string;
  width: number;
  height: number;
}

interface ListItemFromCraft {
  listItemText: string;
}

interface FeatureFromCraft {
  tabHeadline: string;
  description: string;
  image: AssetImageFromCraft;
  listItems: ListItemFromCraft[];
}

interface ModuleFeatureExploration {
  headerSansSerif: string;
  headerSerif: string;
  explorationTabs: FeatureFromCraft[];
  styleOverrides: StyleOverride;
}

const formList = (listItems: ListItemFromCraft[]): string[] => {
  const list: string[] = listItems.map((listItem) => {
    return listItem.listItemText;
  });

  return list;
}

const formFeatures = (items: FeatureFromCraft[]): TextMediaAccordionProps['features'] => {
  return items.map((feature) => ({
    image: (
      <Image
        src={feature.image[0].url}
        width={feature.image[0].width}
        height={feature.image[0].height}
        alt={feature.image[0].title}
        loading="eager"
      />
    ),
    title: feature.tabHeadline,
    description: parseHtml(feature.description),
    list: formList(feature.listItems),
  }));
}

const setDynamicDisplayPropAttributes = (entry: ModuleFeatureExploration) => {
  displayProps.title = <SerifAndSansSerifHeadline primarySansSerif={entry.headerSansSerif} secondarySerif={entry.headerSerif} />
  displayProps.features = formFeatures(entry.explorationTabs);
  displayProps.styleOverrides = {
    bottomMarginSpacing: 'none',
    topMarginSpacing: 'none'
  };
}

const FeatureExploration = ({ entry }) => {
  if (entry.__typename != 'comparisonModules_featureExploration_BlockType') {
    return null;
  }
  setDynamicDisplayPropAttributes(entry);
  return (
    <div className="bg-violet-100 pt-2 border border-solid border-violet-100">
      <TextMediaAccordion {...displayProps} />
    </div>
  );
};

export default FeatureExploration;
